import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

// Vendor stylesheets — kept minimal. Legacy `animate.css`,
// `astro-animation.css`, `prettyPhoto.css` were dropped 2026-05-24:
// no component references their classes (greppable), so they were
// pure dead weight on the bundle.
import "bootstrap/dist/css/bootstrap.min.css";
import "font-awesome/css/font-awesome.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";

// Project / template stylesheets, ordered specific → general so the
// later ones override.
import "./assets/css/main.css";
import "./assets/css/responsive.css";
import "./assets/css/templatemo-style.css";
import "./assets/css/result_searchbar.css";

// Design tokens — loaded LAST so its custom properties + base resets
// win over the legacy template stylesheets above.
import "./assets/css/tokens.css";
import AOS from "aos";
import "aos/dist/aos.css";
import i18n from "./i18n";
import { ensureGuestSession } from "./services/guestSession";
import toast from "./plugins/toast";
import { initAnalytics } from "./services/analytics";

const app = createApp(App);
app.use(router);
app.use(store);
app.use(i18n);
app.use(toast);
app.mount("#app");

// Mint a guest JWT for the v2 tickets backend as soon as the app
// mounts. Fire-and-forget — the request hits the network in parallel
// with the first paint, and individual booking calls block on the
// promise (`await ensureGuestSession()`) only if they fire before
// it's done. Pre-existing sessionStorage tokens short-circuit.
ensureGuestSession();

// Google Analytics 4 — silent no-op when VUE_APP_GA_MEASUREMENT_ID
// is unset (dev / preview builds). Sends the first page_view on
// initialisation; subsequent SPA navigations are tracked from the
// router's afterEach guard.
initAnalytics();
AOS.init({
  duration: 800,
  once: true,
});
